import { PAYMENT_ERROR_MAP, PAYMENT_TIMEOUT_DYNAMICS_ERROR_CODE, PAYMENT_TIMEOUT_STATUSES } from './payment-error.constants';
import { IPaymentError, IPaymentErrorMapEntry } from './payment-error.types';

const normalizeErrorCode = (error: IPaymentError): string | undefined => {
    if (error.name && PAYMENT_ERROR_MAP.has(error.name)) {
        return error.name;
    }

    if (error.status && PAYMENT_TIMEOUT_STATUSES.has(error.status)) {
        return PAYMENT_TIMEOUT_DYNAMICS_ERROR_CODE;
    }

    return undefined;
};

export const mapPaymentError = (error: IPaymentError): IPaymentErrorMapEntry | undefined => {
    const errorCode = normalizeErrorCode(error);
    return errorCode ? PAYMENT_ERROR_MAP.get(errorCode) : undefined;
};
